import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { FC } from 'react';
import { $CurrentGalleryArticle } from '~/components/article-gallery/atoms';
import { WarningLabel } from '~/components/warning-label';

export const WarningLabelSection: FC = () => {
  const article = useScopedAtomValue($CurrentGalleryArticle);

  return <WarningLabel illegalInfo={article.illegalInfo} />;
};
